import { Injectable } from '@angular/core';
import { TranslationImportService } from './translation-import.service';

@Injectable()
export class LocalizationService {

    constructor(private translation: TranslationImportService) {
    }

    public addLocale() {

    }

    public removeLocale() {

    }

    public getLocales() {

    }

    public setLocale() {

    }

    public getLocale() {

    }

    public setFallbackLocale() {

    }

    public getFallbackLocale() {

    }

    public setTranslation() {

    }

    public getTranslation() {

    }

    public setTranslations(endpointUrl: string, languageCode: string) {
        this.translation.setTranslations(endpointUrl, languageCode);
    }

    public getTranslations() {

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/localization/services/localization.service.ts